import { getBasedUrl } from "./get-based-url";
import { isPageUrl } from "./is-page-url";
const getEditableUrl = (url, baseUrl) => typeof url !== "string" ? void 0 : isPageUrl(url) ? getBasedUrl(url, baseUrl || "") : url;
export {
  getEditableUrl
};
//# sourceMappingURL=get-editable-url.js.map
